import { Link } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Seo } from "@/components/Seo";
import { Button } from "@/components/ui/button";
import { FaqList, JsonLd, faqJsonLd } from "@/components/FaqList";
import { FAQ } from "@/lib/seoPages";

const LD = faqJsonLd(FAQ);

export default function Faq() {
  return (
    <div className="min-h-screen bg-background grain" data-testid="faq-page">
      <Seo title="Domande Frequenti sul Noleggio Auto a Pontedera — Centro Auto Pontedera"
        description="Documenti, cauzione, pagamento, carburante, orari e auto sostitutiva: tutte le risposte sul noleggio auto a Pontedera (PI)." path="/domande-frequenti" />
      <JsonLd id="ld-faq" data={LD} />
      <Navbar />
      <section className="max-w-4xl mx-auto px-6 pt-32 pb-10">
        <div className="font-mono-tech text-xs tracking-[0.3em] uppercase amber mb-4">Noleggio auto Pontedera</div>
        <h1 className="font-display text-[1.7rem] sm:text-5xl font-extrabold tracking-tight uppercase leading-none mb-10 break-words">Domande frequenti</h1>
        <FaqList items={FAQ} />
        <div className="rounded-2xl border border-white/10 bg-[#181A22] p-7 mt-10 flex flex-wrap items-center gap-4">
          <p className="flex-1 min-w-[220px] text-sm text-muted-foreground">Non trovi la risposta? Chiamaci allo <a href="tel:+390587484791" className="text-foreground font-semibold">0587 484791</a> o scrivici su WhatsApp.</p>
          <Button asChild className="bg-[#E63946] hover:bg-[#D62828] text-white rounded-full px-7" data-testid="faq-cta"><Link to="/cars">Prenota un'auto</Link></Button>
        </div>
      </section>
      <Footer />
    </div>
  );
}
